import { render, staticRenderFns } from "./CcDesc.vue?vue&type=template&id=44bcd322&scoped=true&"
import script from "./CcDesc.vue?vue&type=script&lang=js&"
export * from "./CcDesc.vue?vue&type=script&lang=js&"
import style0 from "./CcDesc.vue?vue&type=style&index=0&id=44bcd322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bcd322",
  null
  
)

export default component.exports